import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

export const MainCopy = styled.h1`
  font-size: 32px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 24px;

  ${mediaMin.xs`
    font-size: 48px;
  `}

  ${mediaMin.sm`
    font-size: 56px;
    line-height: 1.1;
  `}

  ${mediaMin.lg`
    font-size: 74px;
    line-height: 1.2;
  `}
`;

export const SubCopy = styled.p`
  font-size: 18px;
  line-height: 1.2;
  margin-bottom: 32px;

  ${mediaMin.xs`
    font-size: 20px;
  `}

  ${mediaMin.lg`
    font-size: 22px;
    margin-bottom: 32px;
  `}
`;
